import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Navbar from "../Navigation/Navbar";
import SearchComponent from '../components/SearchComponent';
import ListResultComponent from '../components/ListResultsComponent';
import 'bootstrap/dist/css/bootstrap.min.css';

const Home: React.FC = () => {
  
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [serialNumber, setSerialNumber] = useState('');

  return (
    <div>
      <Navbar />
      <SearchComponent onFilterChange={(startDate:any, endDate:any, serialNumber:any) => {
        setStartDate(startDate);
        setEndDate(endDate);
        setSerialNumber(serialNumber);
      }} />
      <ListResultComponent startDate={startDate} endDate={endDate} serialNumber={serialNumber} />
    </div>
  );
};

export default Home;